import React from 'react';
import PropTypes from 'prop-types';
import {Container, Text} from './project_indicator_text_style';
import {ProjectIndicator} from '../project-indicator';

export const ProjectIndicatorText = ({
	name,
	id,
	color,
	isConnectedProject,
	clearSubPath,
	project,
	text,
	noTitle,
	disableLink,
}) => {
	return (
		<Container>
			<ProjectIndicator
				name={name}
				id={id}
				color={color}
				isConnectedProject={isConnectedProject}
				clearSubPath={clearSubPath}
				project={project}
				noTitle={noTitle}
				disableLink={disableLink}
			/>
			<Text title={text}>{text}</Text>
		</Container>
	);
};

ProjectIndicatorText.propTypes = {
	name: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	color: PropTypes.string,
	isConnectedProject: PropTypes.bool,
	text: PropTypes.string,
	project: PropTypes.object,
	clearSubPath: PropTypes.bool,
	noTitle: PropTypes.bool,
	disableLink: PropTypes.bool,
};

ProjectIndicatorText.defaultProps = {
	clearSubPath: false,
};
